/**
 * Single source of truth for the build marker.
 *
 * Bumped on every change so the user can verify the preview is fresh.
 * Logged to the console by `src/main.tsx` when `?debug=true` is in the URL and
 * stamped into every debug clipboard export.
 */
export const APP_VERSION = 'v19.231.0-water-lint-fixes';
